<template>
  <!--      Modal Actual -->
  <b-modal
    id="modal-assign-agent"
    ref="modal"
    v-model="open"
    size="xl"
    no-close-on-backdrop
    hide-footer
    title="ASSIGN AGENT"
  >
    <b-card title="Rate Card - Loyal Agents">
      <b-overlay
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-row>
          <b-col class="d-flex justify-content-start align-items-center flex-wrap">
            <b-form-group
              label="Agents"
              class="w-75 mr-1"
            >
              <v-select
                v-model="agent_ids"
                :options="agentOptions"
                multiple
                :reduce="option => option.id"
                label="name"
                deselect-from-dropdown
                @input="handleRemovedValue"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
            <div v-if="rateCardStatus === 1">
              <b-form-group class="mt-md-2">
                <b-button
                  v-if="agent_ids.length === 0"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-tooltip.hover.v-primary="'Select All'"
                  variant="outline-primary"
                  class="mr-1"
                  style="margin-top:4px;"
                  @click="onClickSelectAll()"
                >
                  <feather-icon icon="CheckSquareIcon" />
                </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="custom-button-color"
                  style="margin-top:4px;"
                  :disabled="agent_ids.length === 0"
                  @click="AssignAgents()"
                >
                  Assign
                </b-button>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="rows"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            show-empty
          >
            <template #empty>
              <TableDataFetching
                :rows="rows"
                :data-loading="dataLoading"
              />
            </template>
            <template #cell(name)="data">
              <div class="d-flex align-items-center">
                <b-avatar
                  :text="avatarText(data.name)"
                  size="32"
                  variant="light-primary"
                />
                <div>
                  <div class="font-weight-bolder ml-1">
                    {{ data.item.name }}
                  </div>
                  <div class="font-small-2 ml-1">
                    {{ data.item.ref_no }}
                  </div>
                </div>
              </div>
            </template>
          </b-table>
        </b-row>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-sm-start"
              cols="12"
              md="3"
            >
              <label class="width-75">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block ml-1 width-100 mr-2"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              class="d-flex align-items-center justify-content-sm-end"
              cols="12"
              md="9"
            >
              <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :per-page="perPage"
                :total-rows="(meta.total)? meta.total : 0"
                class="mb-0 mt-1 mt-sm-0"
                first-number
                last-number
                next-class="next-item"
                prev-class="prev-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BTable,
  BCol,
  BFormGroup,
  BCard,
  BRow,
  BOverlay,
  BAvatar,
  VBTooltip,
  VBModal,
  BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const RateCardRepository = RepositoryFactory.get('ratecard')
const ResourceRepository = RepositoryFactory.get('resource')

function initialState() {
  return {
    avatarText,
    open: false,
    id: null,
    modalLoading: false,
    dataLoading: false,
    meta: {},
    form: {},
    agent_ids: [],
    agentOptions: [],
    perPage: 20,
    pageOptions: [10, 20, 50],
    totalRows: 1,
    page: 1,
    sortBy: '',
    sortDesc: false,
    sortDirection: 'asc',
    fields: [
      {
        key: 'id', label: '#', thClass: 'text-left', tdClass: 'text-left',
      },
      {
        key: 'name', label: 'Name', thClass: 'text-left', tdClass: 'text-left',
      },
      { key: 'primary_address', label: 'Address', sortable: true },
      { key: 'primary_email', label: 'Email', sortable: true },
    ],
    rows: [],
    agentValue: [],
    agentCount: 0,
    isRemoveConfirmed: null,
    rateCardStatus: null,
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BAvatar,
    BCol,
    BFormGroup,
    BCard,
    BRow,
    BTable,
    BOverlay,
    BPagination,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  watch: {
    page() {
      this.fetchAssignedAgentList()
    },
    perPage() {
      this.fetchAssignedAgentList()
    },
  },
  methods: {
    async openModal(id, rateCardStatus) {
      await Object.assign(this.$data, initialState())
      this.open = true
      this.id = id
      this.rateCardStatus = rateCardStatus
      await this.fetchAssignedAgentList()
      await this.fetchAgentList()
    },
    async fetchAgentList() {
      this.modalLoading = true
      try {
        this.agentOptions = localStorage.getItem('agent_list') ? JSON.parse(localStorage.getItem('agent_list')) : (await ResourceRepository.getAgencyListDropdown()).data.data
        if (!localStorage.getItem('agent_list')) localStorage.setItem('agent_list', JSON.stringify(this.agentOptions))
      } catch (e) {
        this.showErrorMessage('Sorry for the inconvece! Please Try Again!!')
      }
      this.modalLoading = false
    },
    async fetchAssignedAgentList() {
      this.dataLoading = true
      try {
        const { data } = (await RateCardRepository.getAssignedAgentRateCardList(this.id, this.page, this.perPage))
        this.rows = data.data
        this.meta = data.meta
        this.agent_ids = data.agent_ids
        this.agentValue = data.agent_ids
        this.agentCount = this.agent_ids.length
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async AssignAgents() {
      this.modalLoading = true
      try {
        const payload = {
          agent_ids: this.agent_ids,
        }
        await RateCardRepository.assignAgentList(this.id, payload)
        this.showSuccessMessage('Agents updated successfully')
        if (!this.isRemoveConfirmed) {
          this.open = false
          this.agentOptions = []
        }
        this.isRemoveConfirmed = null
        this.$parent.onClickRefresh()
        localStorage.removeItem('agent_list')
        this.fetchAssignedAgentList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    onClickSelectAll() {
      this.agent_ids = this.agentOptions.map(m => m.id)
    },
    onClickDeselectAll() {
      this.agent_ids = []
    },
    async handleRemovedValue(agentSet) {
      if (this.rateCardStatus !== 1) {
        return
      }
      if (agentSet.length > this.agentValue.length) {
        this.agentValue = agentSet.map(item => item)
      } else {
        this.modalLoading = true
        if (this.agentCount !== 0) {
          await this.showMsgBox()
        }
        if (this.isRemoveConfirmed === false) {
          this.agent_ids = this.agentValue.map(item => item)
        }
        if (this.isRemoveConfirmed === true) {
          this.agentValue = agentSet.map(item => item)
          this.AssignAgents()
        }
        this.modalLoading = false
      }
    },
    async showMsgBox() {
      const dialogText = 'Are you certain about removing the agent?'
      return this.$swal({
        title: 'Are you sure?',
        text: dialogText,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm!',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        backdrop: 'modal-no-backdrop',
      }).then(value => {
        this.isRemoveConfirmed = value.isConfirmed
      })
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select.scss';
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
